import { Icon, Paragraph, Subtitle } from '@joor/design-system'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  .warning-icon svg g {
    fill: var(--color-error-600);
  }

  .refresh-button {
    color: var(--color-secondary-800);
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
`

const ErrorState = () => {
  const handleClick = () => {
    window.location.reload()
  }

  return (
    <Wrapper>
      <Icon
        className="warning-icon"
        iconName="exclamation"
        iconSize="extraLarge"
        plain
      />
      <Subtitle>Error loading page</Subtitle>
      <Paragraph textAlign="center">
        We were unable to load this page,{' '}
        <span onClick={handleClick} className="refresh-button">
          refresh
        </span>
        <br /> to try again.
      </Paragraph>
    </Wrapper>
  )
}

export default ErrorState
